import { useContext } from 'react';
import ChatProviderContext from '../stores/contexts/chat-context';

function useChat() {
  const context = useContext(ChatProviderContext);

  if (!context) throw new Error('useChat must be used within a ChatProvider');

  return context;
}

export default useChat;
